export default __webpack_public_path__ + "2a6dec1227f9970376f578270a642d06.woff2";